import { render, staticRenderFns } from "./TermsAndConditionsDetails.vue?vue&type=template&id=4040e54a&"
import script from "./TermsAndConditionsDetails.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports